import React from "react";
import { Stack } from "@mui/material";
import { useState, useEffect } from "react";

export default function SingleSkill({ val }) {
  const [borderColor, setBorderColor] = useState("white");

  useEffect(() => {
    const colors = ["#00adb5", "#5f246f", "#0e8886", "skyblue", "#5c496c"];
    const interval = setInterval(() => {
      const randomIndex = Math.floor(Math.random() * colors.length);
      setBorderColor(colors[randomIndex]);
    }, 3000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <Stack
      data-aos="fade-up"
      data-aos-duration="3000"
      style={{
        backgroundColor: "",
        color: "white",
        padding: "10px",
        borderRadius: "20px",
        border: `solid ${borderColor}`,
        height: "45px",
        fontFamily: "Getboreg Trial Only",
        alignItems: "center",
        justifyContent: "center",
        animation:
          val.id % 2 === 0
            ? "shiningEven 2s infinite linear"
            : "shiningOdd 2s infinite linear",
      }}
      direction="row"
      gap="9px"
    >
      <img
        src={val.img}
        alt=""
        style={{
          width: "20px",
          height: "20px",
          animation: "rotation 5s infinite linear",
          transformStyle: "preserve-3d",
        }}
      />
      <span>{val.name}</span>
    </Stack>
  );
}
